import PropTypes from "prop-types";
import { kloString } from "src/components/js/statics1";
import { keikkaString_html } from "src/pages/keikkaGrid/components/common";
import { useDarkModeData } from "src/context/DarkModeContext";
import { ReportContext, reportContext_defaultSettingsData } from "src/context/ReportContext";
import { useContext, useEffect, useState } from "react";
import { asiakas_fetch } from "src/data/asiakas/AsiakasFunctions";
import { useUserData } from "src/context/userContext";

export default function Report_ReportComponent_Keikka({ keikka }) {
  const context = useContext(ReportContext);
  // const { settingsData } = useContext(ReportContext) || {};
  const { user, token } = useUserData();
  const { darkMode } = useDarkModeData();
  const [sourceAsiakasNimi, setSourceAsiakasNimi] = useState(null);

  // Fallback to default settings if context is not available
  const settingsData = context?.settingsData || reportContext_defaultSettingsData;
  useEffect(() => {
    if (!keikka.isKeikka) return; // only keikka has sourceAsiakasId
    if (!settingsData.showSource) return; // only show source if settingsData.showSource is true
    if (sourceAsiakasNimi) return; // already fetched
    asiakas_fetch(user, keikka.sourceAsiakasId, token).then((a) =>
      setSourceAsiakasNimi(a.globalAsiakas.asiakasNimi)
    );
  }, [keikka.sourceAsiakasId, settingsData?.showSource]);

  if (!keikka) return null;
  if (!settingsData.showComments && keikka.isPalkki) return null;

  return (
    <div
      style={{
        display: "flex",
        paddingTop: keikka.isKeikka ? settingsData.rowSpacing : 0,
        transition: "0.3s all ease-in-out",
        gap: 4,
        alignItems: "flex-start",
        width: "100%",
      }}
      className="fixPrint">
      <PalkkiKloString keikka={keikka} />
      <div style={{ flex: 1 }}>
        {keikka.isKeikka && settingsData.showSource && (
          <div style={{ display: "flex" }}>
            <div style={{ fontWeight: "bold" }}>{sourceAsiakasNimi}</div>
            <div style={{ fontSize: "0.8em" }}>
              #{keikka.keikkaId}
              {keikka.foreignKey && `/${keikka.foreignKey}`}
            </div>
          </div>
        )}
        <div
          style={{
            flex: 1,
            fontSize: settingsData.bodyFontSize,
            fontStyle: keikka.isKeikka ? "normal" : "italic",
            transition: "0.3s all ease-in-out",
          }}
          dangerouslySetInnerHTML={{
            __html: keikkaString_html(
              keikka,
              null,
              1,
              darkMode,
              settingsData.showSource ? "" : "<small>#{keikkaId} {foreignKey}</small>"
            ),
          }}
        />
      </div>
    </div>
  );

  function PalkkiKloString({ keikka }) {
    return (
      <div
        style={{
          width: 60,
          fontSize: settingsData.bodyFontSize,
          transition: "0.3s all ease-in-out",
        }}>
        {kloString(keikka.timeStart)}
      </div>
    );
  }
}

Report_ReportComponent_Keikka.propTypes = {
  keikka: PropTypes.object,
};
